<template lang="pug">
  .component-reservation-survey-configuration
    .row(v-for="elem, index in value")
      .column.shrink.delete
        DeleteConf(@click="value.splice(index, 1)")
      .column(v-for="val, inx in elem")
        label(v-if="inx === 'reporting_type_id'") {{inx}}
          select(v-model="value[index].reporting_type_id")
            option(:value="null") --
            option(v-for="type in reportingTypes", :value="type.id") {{type.name}}
        label(v-else-if="inx === 'rating_threshold'") {{inx}}
          input(type="number", min="1", max="5", v-model="value[index][inx]")
        .mandatory(v-else-if="inx === 'mandatory'")
          label {{inx}}
          input(type="checkbox", v-model="value[index].mandatory")
        label(v-else) {{inx}}
          input(type="text", v-model="value[index][inx]")
</template>

<script>
  import DeleteConf from './DeleteConf'
  import KeplerBackofficeSdk from '../../../lib/kepler/backoffice'
  import {mapState} from 'vuex'

  export default {
    name: 'ReservationSurveyConfiguration',
    components: {DeleteConf},
    data() {
      return {
        reportingTypes: []
      }
    },
    created() {
      KeplerBackofficeSdk.selects.reportingTypes((data) => {
        this.reportingTypes = data
      })
    },
    computed: {
      ...mapState({
        configuration: state => state.configuration,
      })
    },
    props: ['value', 'item']

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ReservationSurveyConfiguration.vue?447849d8